/**
 * Иконки типов элементов.
 *
 * Имя иконки задано в реестре типов; здесь оно превращается в компонент.
 * Явный список вместо динамического импорта — так сборщик знает, какие
 * иконки нужны, и не тянет в бандл всю библиотеку.
 */

import {
  BadgeCheckIcon,
  ChartNoAxesColumnIcon,
  CircleHelpIcon,
  FlaskConicalIcon,
  GavelIcon,
  KeyRoundIcon,
  Link2Icon,
  MicroscopeIcon,
  OctagonXIcon,
  PackageIcon,
  ReceiptIcon,
  SquareCheckIcon,
  StickyNoteIcon,
  TriangleAlertIcon,
  WrenchIcon,
  type LucideIcon,
} from 'lucide-react';
import { getItemTypeDefinition, type ItemType } from '@project-os/contracts';
import { cn } from '@/lib/utils';

const ICONS: Record<string, LucideIcon> = {
  StickyNote: StickyNoteIcon,
  Link2: Link2Icon,
  Microscope: MicroscopeIcon,
  BadgeCheck: BadgeCheckIcon,
  ChartNoAxesColumn: ChartNoAxesColumnIcon,
  FlaskConical: FlaskConicalIcon,
  CircleHelp: CircleHelpIcon,
  Gavel: GavelIcon,
  SquareCheck: SquareCheckIcon,
  TriangleAlert: TriangleAlertIcon,
  OctagonX: OctagonXIcon,
  Package: PackageIcon,
  Wrench: WrenchIcon,
  KeyRound: KeyRoundIcon,
  Receipt: ReceiptIcon,
};

export function getItemIcon(type: ItemType): LucideIcon {
  return ICONS[getItemTypeDefinition(type).icon] ?? StickyNoteIcon;
}

export function ItemTypeIcon({ type, className }: { type: ItemType; className?: string }) {
  const Icon = getItemIcon(type);
  return <Icon className={cn('size-4 shrink-0 text-muted-foreground', className)} aria-hidden />;
}

/** Иконка с подписью типа. Используется в таблице и карточке элемента. */
export function ItemTypeLabel({ type, className }: { type: ItemType; className?: string }) {
  const definition = getItemTypeDefinition(type);
  return (
    <span className={cn('inline-flex items-center gap-1.5 text-muted-foreground', className)}>
      <ItemTypeIcon type={type} />
      {definition.labelRu}
    </span>
  );
}
